<template>
    <tab-layout>
        <!-- TAB TITLE -->
        <template #title>
            {{ $l10n.__('Informations Générales') }}
        </template>

        <!-- TAB CONTENT -->
        <template #content>
            <div class="well p-0 pb-3 flex-level flex-top ovx-auto">
                <!-- OPPORTUNITY -->
                <section class="flex">
                    <h3 class="m-3 flex-row baseline">{{ $l10n.__("L'opportunité") }}</h3>
                    <div class="px-3 br-1">
                        <ul>
                            <li
                                v-for="(item, indexItem) in removeEmptyValue(general)"
                                :key="indexItem"
                                class="data-block data-block-hover"
                            >
                                <!-- Dynamic load data component -->
                                <component :is="item.format + '-data'" v-bind="item"> </component>
                            </li>
                        </ul>
                    </div>
                </section>

                <!-- THIRD -->
                <section class="flex">
                    <h3 class="m-3 flex-row baseline">
                        <span class="flex-right">
                            <link-button
                                :permissions="$store.getters.permissions"
                                perm-to-check="can_edit"
                                :data-bot="databot['generalinfoedit1']"
                                @clicked="editOpportunity"
                            >
                                {{ $l10n.__('Editer') }}
                            </link-button>
                        </span>
                    </h3>

                    <div class="px-3">
                        <h4 class="m-0">
                            {{ isCorporation ? $l10n.__('Société') : $l10n.__('Particulier') }}
                        </h4>

                        <!-- Corp -->
                        <ul>
                            <li
                                v-for="(item, indexItem) in removeEmptyValue(third)"
                                :key="indexItem"
                                class="data-block data-block-hover"
                            >
                                <!-- Dynamic load data component -->
                                <component :is="item.format + '-data'" v-bind="item"> </component>
                            </li>
                        </ul>

                        <!-- Contacts -->
                        <div v-if="isCorporation">
                            <div
                                v-for="(contact, contactIndex) in linkedContacts"
                                :key="contactIndex"
                                class="mt-4"
                            >
                                <h4 class="m-0">{{ contact.name }}</h4>
                                <ul>
                                    <li
                                        v-for="(item, indexItem) in removeEmptyValue(contact.data)"
                                        :key="indexItem"
                                        class="data-block data-block-hover"
                                    >
                                        <!-- Dynamic load data component -->
                                        <component :is="item.format + '-data'" v-bind="item">
                                        </component>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- SELLSY -->
                <sellsy-informations-section
                    :linkedid="$store.getters.linkedid"
                    :linkedtype="$store.getters.linkedtype"
                    :enable-tags="true"
                />
            </div>
        </template>
    </tab-layout>
</template>

<script>
import LinkButton from 'vcomponents/utilities/LinkButton.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';
import SellsyInformationsSection from './SellsyInformationsSection.vue';
import Text from './data/Text.vue';
import TextArea from './data/Textarea.vue';
import Days from './data/Days.vue';
import Link from './data/Link.vue';
import ExternalLink from './data/ExternalLink.vue';
import Phone from './data/Phone.vue';
import Email from './data/Email.vue';
import Date from './data/Date.vue';

import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    components: {
        'sellsy-informations-section': SellsyInformationsSection,
        'text-data': Text,
        'textarea-data': TextArea,
        'days-data': Days,
        'link-data': Link,
        'external_url-data': ExternalLink,
        'phone-data': Phone,
        'email-data': Email,
        'date-data': Date,
        'link-button': LinkButton,
        TabLayout,
    },
    props: {},
    data() {
        return {
            mapping: this.$store.getters.dataMap,
        };
    },
    computed: {
        infoData() {
            return this.$store.getters.dataFetch;
        },
        third() {
            const self = this;
            self.mapping.third.map((map) => {
                const info = self.infoData.third.find((info) => info.key == map.id);
                map.value = info !== undefined ? info.value : '';
                map.linkedtype = 'third';
                map.linkedid = parseInt(
                    self.infoData.third.find((info) => info.key === 'id').value,
                );
                if (map.format === 'link') {
                    const link = self.infoData.third.find((info) => info.key === 'link');
                    map.link = link !== undefined ? link.value : '';
                }
            });

            if (!this.isThirdActive) {
                const inactiveThirdMap = this.mapping.third.find(
                    (oneThird) => oneThird.id === 'name',
                );
                inactiveThirdMap.tooltip = {
                    text: this.$l10n.__(`Cette société est supprimée`),
                    position: 'top',
                };
                return [inactiveThirdMap];
            }

            return this.mapping.third;
        },
        isCorporation() {
            return (
                this.infoData.third.find((oneThird) => oneThird.key === 'type').value ==
                'corporation'
            );
        },
        isThirdActive() {
            return this.infoData.third.find((oneThird) => oneThird.key === 'active').value == true;
        },
        linkedContacts() {
            const contactsData = [];
            if (this.infoData.contacts.length > 0) {
                let cpt = 1;
                this.infoData.contacts.map((contact) => {
                    const dataContact = {
                        name:
                            this.$l10n.__('Contact') +
                            ' ' +
                            (this.infoData.contacts.length > 1 ? cpt : ''),
                        data: [],
                    };
                    const currentMapping = JSON.parse(JSON.stringify(this.mapping));
                    currentMapping.contacts.map((map) => {
                        const info = contact.find((info) => info.key == map.id);
                        map.value = info !== undefined ? info.value : '';
                        map.linkedtype = 'people';
                        map.linkedid = parseInt(
                            contact.find((info) => info.key === 'peopleId').value,
                        );
                        if (map.format == 'link') {
                            const link = contact.find((info) => info.key === 'link');
                            map.link = link !== undefined ? link.value : '';
                        }

                        dataContact.data.push(map);
                    });
                    contactsData.push(dataContact);
                    cpt++;
                });
            }
            return contactsData;
        },
        general() {
            const self = this;
            self.mapping.informations.map((map) => {
                const info = self.infoData.informations.find((info) => info.key == map.id);
                map.value = info !== undefined ? info.value : '';
            });
            return this.mapping.informations;
        },
        databot() {
            return this.$store.getters.databots;
        },
    },
    created() {
        EventBus.on('opportunity:update', (payload) => {
            this.$store.dispatch('updateInformations', payload.data.informations);
            this.$store.dispatch('updateSellsyInformations', payload.data.sellsy);
            EventBus.emit('overview:sellsyinformation:update', payload.data.sellsy);
            this.$store.dispatch('updateContacts', payload.data.contacts);
            this.$store.dispatch('updateThird', payload.data.third);
        });
    },

    methods: {
        ...popupPanelMapActions(['open']),
        removeEmptyValue(list) {
            return list.filter(
                (item) =>
                    (item.value && item.id === 'dueDate' && item.value !== '0000-00-00 00:00:00') ||
                    (item.id !== 'dueDate' && item.value != ''),
            );
        },
        editOpportunity() {
            this.open({
                key: 'opportunityForm',
                props: {
                    context: 'overview',
                    mode: 'edit',
                    action: 'edit',
                    oppId: this.$store.getters.linkedid,
                    emitEditSuccess: 'opportunity:update',
                },
            });
        },
    },
};
</script>
